module.exports = __webpack_public_path__ + "img/A.0ca1989f.png";